import { usePrevious } from 'utils/hooks/previous';

export const usePrimitiveHaveBeenChanged = <T>(value: T) => {
  const previousPrimitive = usePrevious(value);

  return previousPrimitive !== undefined && value !== previousPrimitive;
};
